import EmblaCarousel from "embla-carousel";

document.addEventListener("DOMContentLoaded", (event) => {
	const testimonialsCarousels = document.querySelectorAll(".testimonials-carousel__wrapper");

	if (testimonialsCarousels && testimonialsCarousels.length > 0) {
		testimonialsCarousels.forEach((rootNode) => {
			const hasSliderEnabled = rootNode.getAttribute("data-carousel");

			if (hasSliderEnabled !== "true") return;
			const viewportNode = rootNode.querySelector(".testimonials-carousel__inner"); // embla__viewport
			const container = rootNode.querySelector(".testimonials-carousel__inner > div"); //embla__container

			const btnGroup = document.createElement("div");
			btnGroup.className = "carousel-arrows-group";
			btnGroup.innerHTML = `
						<button class="btn-prev btn-arrow" type="button" ><span class="sr-only">Previous Resource</span><i class="varcon-icon-arrow-icon" aria-hidden="true"></i></button>
<button class="btn-next btn-arrow" type="button" ><span class="sr-only">Next Resource</span><i class="varcon-icon-arrow-icon" aria-hidden="true"></i></button>
				`;

			if (!container) return;
			viewportNode.before(btnGroup);

			const prevBtn = rootNode.querySelector(".btn-prev");
			const nextBtn = rootNode.querySelector(".btn-next");

			// Initialize the carousel
			const options = {
				loop: true,
				align: "center",
				containScroll: false,
				slidesToScroll: 1,
				// breakpoints: {
				// 	"(max-width: 981px)": { slidesToScroll: 2 },
				// 	"(max-width: 768px)": { slidesToScroll: 1 },
				// },
			};
			const embla = EmblaCarousel(viewportNode, options);

			nextBtn.addEventListener("click", (e) => {
				e.preventDefault();
				embla.scrollNext();
			});
			prevBtn.addEventListener("click", (e) => {
				e.preventDefault();
				embla.scrollPrev();
			});

			// Disable/Re-enable buttons when scrolled to first or last item
			function toggleButtonsDisabled(embla) {
				const setButtonState = (button, enabled) => {
					button.toggleAttribute("disabled", !enabled);
				};

				setButtonState(prevBtn, embla.canScrollPrev());
				setButtonState(nextBtn, embla.canScrollNext());
			}

			toggleButtonsDisabled(embla);
			embla.on("select", toggleButtonsDisabled);
			embla.on("reinit", toggleButtonsDisabled);
		});
	}
});
